import ImageComponent from '@components/common/ImageComponent/ImageComponent';
import ivclass from '@invideoio/web-shared/Modules/IVClass';
import { PlatformType } from '@invideoio/web-shared/constants/common';
import { StateContext } from '@store/store';
import { openLiveChat } from '@utils/common.utils';
import {
  AssetsAppName,
  SupportBannerBg,
  SupportBannerBgSm,
  getWebAssetsUrl,
} from '@utils/web-assets';
import { useContext } from 'react';
import Description from './components/Description';
import Title from './components/Title';

const SupportBanner = () => {
  const globalState = useContext(StateContext);

  const { platform } = globalState;

  const bgImgPath =
    platform === PlatformType.Mobile ? SupportBannerBgSm : SupportBannerBg;
  const backgroundImgUrl = getWebAssetsUrl(bgImgPath, AssetsAppName.COMMON);

  return (
    <div
      className={ivclass(
        'xl:iv-mx-[140px] lg:iv-mx-40 md:iv-mx-25 sm:iv-mx-20',
      )}
    >
      <div
        className={ivclass(
          'iv-w-full',
          'iv-max-w-[1200px]',
          'xl:iv-h-[450px]',
          'lg:iv-h-[400px]',
          'md:iv-h-[360px]',
          'sm:iv-h-[450px]',
          'iv-rounded-25',
          'xl:iv-rounded-30',
          'iv-relative',
          'iv-bg-grey-90',
          'iv-overflow-hidden',
          'iv-cursor-pointer',
        )}
        onClick={openLiveChat}
      >
        <div
          className={ivclass(
            'iv-z-[1]',
            'iv-relative',
            'iv-w-full',
            'iv-h-full',
            'xl:iv-p-40',
            'iv-p-35',
            'iv-flex',
            'sm:iv-flex-col',
            'iv-justify-start',
          )}
        >
          <div
            className={ivclass(
              'xl:iv-w-[520px]',
              'lg:iv-w-[483px]',
              'md:iv-w-[358px]',
              'sm:iv-w-full',
              'iv-h-full',
              'iv-flex',
              'iv-flex-col',
            )}
          >
            <div>
              <Title />
            </div>
            <div className={ivclass('xl:iv-mt-35', 'iv-mt-25', 'sm:iv-mt-20')}>
              <Description />
            </div>
            <div className={ivclass('iv-mt-40', 'sm:iv-mt-20')}>
              <button
                className={ivclass(
                  'iv-bg-blue',
                  'iv-rounded-[110px]',
                  'sm:iv-rounded-[80px]',
                  'iv-px-20 iv-py-[14px]',
                  'sm:iv-px-10 sm:iv-py-[4px]',
                )}
              >
                <div
                  className={ivclass(
                    'iv-text-body-2xl iv-m-body-2xl',
                    'iv-font-semibold',
                    'iv-text-grey-0',
                  )}
                >
                  Talk to Us
                </div>
              </button>
            </div>
          </div>
        </div>
        <ImageComponent
          elementype="native"
          className={ivclass(
            'iv-h-full sm:iv-h-auto',
            'sm:iv-w-full',
            'iv-right-0',
            'iv-top-0',
            'iv-absolute',
            'iv-object-contain',
            'sm:iv-object-cover',
            'iv-z-[0]',
          )}
          src={backgroundImgUrl}
          alt="Support Background"
        />
      </div>
    </div>
  );
};

export default SupportBanner;
